import { render, staticRenderFns } from "./CardStatsV8.vue?vue&type=template&id=51e7f684&scoped=true&"
import script from "./CardStatsV8.vue?vue&type=script&lang=js&"
export * from "./CardStatsV8.vue?vue&type=script&lang=js&"
import style0 from "./CardStatsV8.vue?vue&type=style&index=0&id=51e7f684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7f684",
  null
  
)

export default component.exports